module.exports = __webpack_public_path__ + "static/img/light2.bcb331d5.png";